import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/layout/Layout";
import TawkController from "@/components/common/TawkController";
import Home from "@/pages/Home";
import About from "@/pages/About";
import WhyChooseUs from "@/pages/WhyChooseUs";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Employers from "@/pages/Employers";
import Candidates from "@/pages/Candidates";
import PartnershipDetail from "@/pages/PartnershipDetail";
import PartnershipCenter from "@/pages/PartnershipCenter";
import CeoGate from "@/pages/admin/CeoGate";
import PartnerDashboard from "@/pages/partner/PartnerDashboard";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Accessibility from "@/pages/Accessibility";
import SpeakUp from "@/pages/SpeakUp";
import CookiePolicy from "@/pages/CookiePolicy";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <TawkController />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/why-choose-us" element={<WhyChooseUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/employers" element={<Employers />} />
            <Route path="/candidates" element={<Candidates />} />
            <Route path="/partnerships/:slug" element={<PartnershipDetail />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/legal/:slug" element={<Legal />} />
            <Route path="/accessibility" element={<Accessibility />} />
            <Route path="/speak-up" element={<SpeakUp />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
          </Route>
          <Route path="/partnerships" element={<PartnershipCenter />} />
          <Route path="/partner-dashboard" element={<PartnerDashboard />} />
          <Route path="/admin/gate" element={<CeoGate />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
